import * as moment from 'moment-timezone';

export const convertMiliSecondsToTimeString = (milliseconds: number) => {
  const diff = moment.duration(milliseconds);
  const minutes = diff.minutes();
  const hours = Math.floor(diff.asHours());

  const hoursString = hours > 0 ? `${hours}h` : '';
  const minutesString = minutes > 0 ? `${minutes} min` : '';

  return [hoursString, minutesString].filter((seq) => seq !== '').join(' ');
};

export const getFormattedDate = (props: {
  minutesShift?: number;
  date: moment.Moment;
}) => {
  const { date, minutesShift } = props;
  return getFormattedMoment(date, minutesShift).toDate();
};

export function getFormattedMoment(date: moment.Moment, minutesShift?: number) {
  const momentDate = date.clone();
  const roundedMinutes = Math.ceil(momentDate.minutes() / 15) * 15;

  momentDate.minutes(roundedMinutes + (minutesShift ? minutesShift : 0));
  return momentDate;
}
